/* global updateUrl */

import React, { useEffect, useRef, useState } from 'react';

import { Modal } from 'flowbite';

import PurchaseRequisitionProcurementMethodModal from './PurchaseRequisitionProcurementMethodModal';
import PurchaseRequisitionsEditForm from './PurchaseRequisitionsEditForm';

import { modalOptions } from 'Helpers/modalOptions';

import Button from 'CommonComponents/Button';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function PurchaseRequisitionsEditModal(props) {
    const [prIsUpdated, setPrIsUpdated] = useState(false);
    const [request, setRequest] = useState(false);
    const [requestFailed, setRequestFailed] = useState(false);

    const [purchaseRequisitionProcurementMethodModalElement, setPurchaseRequisitionProcurementMethodModalElement] = useState(null);

    const purchaseRequisitionProcurementMethodModalRef = useRef();

    const [actionCompleted, setActionCompleted] = useState(false);
    const [actionInProgress, setActionInProgress] = useState(false);
    const [actionFailed, setActionFailed] = useState(false);

    useEffect(() => {
        purchaseRequisitionProcurementMethodModalRef &&
            setPurchaseRequisitionProcurementMethodModalElement(new Modal(purchaseRequisitionProcurementMethodModalRef.current, modalOptions(false)));
    }, []);

    const resetData = () => {
        purchaseRequisitionProcurementMethodModalElement && purchaseRequisitionProcurementMethodModalElement.hide();
    };

    const closeModal = () => {
        resetData();
    };

    const successHandler = () => {
        resetData();
    };

    const cleanConfirmationModalStates = () => {
        setActionInProgress(false);
        setActionFailed(false);
        setActionCompleted(false);
    };

    const showPurchaseRequisitionProcurementMethodModal = () => {
        purchaseRequisitionProcurementMethodModalElement && purchaseRequisitionProcurementMethodModalElement.show();
    };

    const cleanStates = () => {
        setRequest(false);
        setRequestFailed(false);
        setPrIsUpdated(false);
    };

    const internalCloseHandler = () => {
        cleanStates();
        props.closeHandler();
    };

    const internalSuccessHandler = () => {
        cleanStates();
        props.successHandler();
    };

    return (
        <>
            <PurchaseRequisitionProcurementMethodModal
                closeHandler={closeModal}
                successHandler={successHandler}
                cleanStates={cleanConfirmationModalStates}
                allowAction={true}
                modalId={'pr-method-list'}
                modalRef={purchaseRequisitionProcurementMethodModalRef}
                modalElement={purchaseRequisitionProcurementMethodModalElement}
                request={actionInProgress}
                actionCompleted={actionCompleted}
                actionFailed={actionFailed}
                title={$t('Procurement Policies')}
                cancelButtonText={$t('Close')}
                policies={props.policies}
            />
            <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
                <div className="modal__container">
                    <div className="modal__inner-container">
                        <ModalHeader title={$t('Edit Purchase Requisition')} close={props.closeHandler}></ModalHeader>
                        <div className="tw-rounded-b">
                            <div className="modal__form-container">
                                {Object.keys(props.pr).length > 0 && (
                                    <>
                                        <div className={!prIsUpdated && !requestFailed ? 'modal__form-container' : 'hidden'}>
                                            <PurchaseRequisitionsEditForm
                                                pr={props.pr}
                                                policies={props.policies}
                                                updateUrl={props.updateUrl || updateUrl}
                                                internalCloseHandler={internalCloseHandler}
                                                setPrIsUpdated={setPrIsUpdated}
                                                request={request}
                                                showInfo={showPurchaseRequisitionProcurementMethodModal}
                                            />
                                        </div>
                                        <div className={prIsUpdated ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                                            <label className="modal__msg modal__text-color">
                                                [{props.pr.pr_code}] {$t('updated')}
                                            </label>
                                        </div>
                                        <div className={requestFailed ? 'tw-grid tw-grid-cols-1' : 'hidden'}>
                                            <label className="modal__msg modal__error-text-color">
                                                [{props.pr.pr_code}] {$t('could not be updated')}
                                            </label>
                                        </div>

                                        {(prIsUpdated || requestFailed) && (
                                            <div className="modal__footer">
                                                <Button variant="secondary" onClick={internalSuccessHandler}>
                                                    {$t('Close')}
                                                </Button>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
